<template>
    <!-- 全局配置注入 -->
    <a-config-provider :renderEmpty="renderEmpty" :locale="locale">
        <div class="vue-app" :class="isIE9 && 'ie9-vue-app'">
            <router-view/>
        </div>
    </a-config-provider>
</template>


<script>
    import Empty from '@/components/Empty.vue';
    import zhCN from 'ant-design-vue/es/locale/zh_CN';
    import moment from 'moment';
    import 'moment/locale/zh-cn';

    const detectIE = require('./util/browser').detectIE();

    const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'cn';
    const langBool = lang.indexOf('cn') > -1;
    if (langBool) moment.locale('zh-cn');
    export default {
        name: 'App',
        data() {
            return {
                isIE9: detectIE === 9,
                status: 0,
                locale: (langBool && zhCN) || null,
                renderEmpty: h => h(Empty, { props: { status: this.status } })
            };
        },
        mounted() {
            this.addBodyClass();
        },
        methods: {
            addBodyClass() { // 给vue模块增加全局class
                window.$('body').addClass(`mix-vue ${this.isIE9 && 'mix-vue-ie9'}`);
            }
        }
    };
</script>
